import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const WHATSAPP_BUSINESS = "917869727989";
export const WHATSAPP_PERSONAL = "919340777640";

export const waLink = (number, text) =>
  `https://wa.me/${number}?text=${encodeURIComponent(text || "Hi, I'm interested in a Golden Retriever puppy from Raijada Dog Kennel.")}`;
